import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider } from 'react-redux';
import store from './Store/Store';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import { BUGSNAG_API_CODE } from './config/config';
import theme from "./theme";
import { ThemeProvider, StyledEngineProvider } from '@mui/material';

if (BUGSNAG_API_CODE) {
    Bugsnag.start({
        apiKey: BUGSNAG_API_CODE,
        plugins: [new BugsnagPluginReact()]
    })
}

const ErrorBoundary = BUGSNAG_API_CODE
    ? Bugsnag.getPlugin('react')
        .createErrorBoundary(React)
    // if not using Bugsnag, create simple pass-through element, so children are still renendered
    : function BugSnagPassthrough({ children }) { return children };
;

const container = document.getElementById('root');
const root = createRoot(container);
root.render((
    <React.StrictMode>
        <ErrorBoundary>
            <ReduxProvider store={store}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <App />
                    </ThemeProvider>
                </StyledEngineProvider>
            </ReduxProvider>
        </ErrorBoundary>
    </React.StrictMode>
));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
